import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';
import { getDecryptedUser } from '../itemPage/ItemPageShared/ItemUtils';
import { IoMdArrowDropdown} from "react-icons/io"

const LedgerFormFields = ({ formFields, errors,setReportData,setErrors, formData,setFormData,filteredReports,
  handleInputChange,handleInputClick,searchValue,isOpen,handleSelect }) => {
    const userData = getDecryptedUser();
    const handleDateChange = (date, name) => {
        setReportData([]);
        setErrors('');
        const validDate = dayjs(date).isValid() ? dayjs(date).format('YYYY/MM/DD') : '';
        setFormData(prevData => ({
          ...prevData,
          [name]: validDate,
          '@cardCode': userData?.[0]?.CardCode || '', // Always append CardCode
        }));
        setErrors(prevErrors => ({ ...prevErrors, [name]: '' }));
      };
  
    return (
      <>
      <div className="textfieldMain"> 
      <div className="typeSelectDiv">
        <TextField
          type="text"
          className="reporttype"
          placeholder="Choose a Report Type" 
          value={searchValue}
          onChange={handleInputChange}
          onClick={handleInputClick}
          variant="standard"
          autoComplete="off"
        /><IoMdArrowDropdown className='downarrow' size={22}/>
        {isOpen && (
          <ul className="dropdownMenu">
            {filteredReports && filteredReports.length > 0 ? (
              filteredReports.map((item, index) => (
                <li
                  className="dropdownItem"
                  key={index}
                  onClick={() => handleSelect(item)}
                >
                  {item.queryName}
                </li>
              ))
            ) : (
              <li className="dropdownItem">No results found</li>
            )}
          </ul>
        )}
      </div>
    </div>
    <div className="fieldsThreeMain">
      <div className="dynamicFields">
        {formFields?.filter(field => field.formControlName !== '@cardCode').map((field, index) => (
          <div key={index}>
            <label style={{ fontSize: '12px', display: 'block' }}>{field.label}</label>
            {field.type === 'date' && (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="dateField"
                  value={formData?.[field.formControlName] ? dayjs(formData[field.formControlName], 'YYYY/MM/DD') : null}
                  onChange={(date) => handleDateChange(date, field.formControlName)}
                  format="DD/MM/YYYY"
                  renderInput={(params) => <TextField {...params} />}
                  required={field.isRequired}
                />
              </LocalizationProvider>
            )}
            {errors?.[field.formControlName] && (
              <span className="text-danger" style={{ fontSize: '12px' }}>
                {errors[field.formControlName]}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
    </>
  );
};

export default LedgerFormFields;